<template>
  <div>
    <div v-if="this.config.type == 'photos'">
      <el-upload :action="uploadUrl" list-type="picture-card" :on-preview="handlePictureCardPreview" :headers="headers"
        :file-list="fileList" :data="config.uploadData" :on-success="success" :on-error="error"
        :before-upload="uploadLimit" :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
    <div v-if="this.config.type == 'photo'">
      <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :data="config.uploadData"
        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="uploadLimit">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <div v-if="this.config.type == 'pdf'">
      <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :file-list="fileList"
        :show-file-list="true" :data="config.uploadData" :on-success="uploadPDF" :on-remove="handleRemove"
        :before-upload="uploadLimit">
        <el-button type="primary" icon="el-icon-upload"></el-button>
      </el-upload>
    </div>
    <div v-if="this.config.type == 'excel'">
      <el-upload class="avatar-uploader" :action="uploadExcelUrl" :headers="headers" :show-file-list="false"
        :data="config.uploadData" :on-success="uploadPDF" :on-remove="handleRemove" :before-upload="uploadExcelLimit">
        <p>{{config.buttonText || $t('common.Import')}}</p>
      </el-upload>
    </div>
    <div v-if="this.config.type == 'any'">
      <el-upload list-type="picture-card" :file-list="fileList" :on-preview="handlePictureCardPreview"
        :action="uploadUrl" :headers="headers" :data="config.uploadData" :on-success="uploadSuccess"
        :on-remove="handleRemove" :before-upload="uploadStyle">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
    <div v-if="this.config.type == 'enclosure'">
      <el-upload :file-list="fileList" :action="uploadUrl" :headers="headers" :data="config.uploadData"
        :on-success="enclosureSuccess" :on-remove="handleRemove" :before-upload="uploadStyle" :show-file-list='false'>
        <el-button size="mini" type="primary" icon="el-icon-upload2">{{$t('cmc.base.salesMan.uploadEnclosure')}}
        </el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  export default {
    props: {
      config: {
        type: '',
        initFileList: []
      }
    },
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        },
        uploadExcelUrl: this.global.CMC_BASE + '/store/importStore',
        uploadUrl: this.global.BASE_FILE + '/upload',
        fileList: this.config.initFileList,
        deleteFileList: [],
        loading: '',
        imageUrl: ''
      }
    },
    watch: {
      config: {
        handler(newValue, oldValue) {
          this.deleteFileList = []
          if (newValue && newValue.uploadUrl) {
            this.uploadExcelUrl = this.config.uploadUrl
          } else {
            this.uploadExcelUrl = ''
          }
          if (newValue && newValue.initFileList && newValue.initFileList[0]) {
            this.fileList = [...newValue.initFileList]
            this.imageUrl = newValue.initFileList[0].url
          } else {
            this.imageUrl = ''
            this.fileList = []
          }
          if (newValue && newValue.uploadData) {
            this.config.uploadData = newValue.uploadData
          } else {
            this.config.uploadData = {
              uuId: new Date().getTime()
            }
          }
        },
        deep: true
      }
    },
    methods: {
      // 文件列表移除文件时的钩子
      // file为点击删除的文件对象,this.fileList为父组件的对应对象,其中有所上传所有的file对象
      handleRemove(file) {
        // 当要删除的file的uid和 fileList中某个file的uid相同时，就删除掉fileList中这个file
        this.deleteFileList.push(file)
        this.fileList.some((item, index) => {
          if (item.uid == file.uid) {
            this.fileList.splice(index, 1)
          }
        })
        this.$emit('success', this.fileList, this.deleteFileList)
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      uploadExcelLimit(file) {
        var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
        const isExcel = (fileType === 'xls' || fileType === 'xlsx')
        const isSize = file.size / 1024 / 1024 < 50 // 限制小于50M
        if (!isSize) {
          this.$message({
            message: '上传图片最大不能超过50M',
            center: true
          })
        }
        if (!isExcel) {
          this.$message({
            message: '请上传正确的文件格式',
            center: true
          })
        }

        if (isSize && isExcel) {
          this.loading = this.$loading({
            lock: true,
            text: '正在上传',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0)'
          })
        }
        return isSize && isExcel
      },
      uploadStyle(file) {
        this.loading = this.$loading({
          lock: true,
          text: '正在上传',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        })
        return file
      },
      uploadSuccess(res, file) {
        this.loading.close()
        if (res.code === '0000') {
          this.$message({
            message: '上传成功',
            center: true,
            type: 'success'
          })
          res.data.file = file
          res.data.url = this.global.DATA_DICT.resource_prefix + res.data.accessPath
          this.fileList.push(res.data)
          this.$emit('success', this.fileList)
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'warning'
          })
        }
      },
      uploadLimit(file) {
        var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
        const isJPG = (fileType === 'jpg' || fileType === 'JPG')
        const isJPEG = (fileType === 'jpeg' || fileType === 'JPEG')
        const isPNG = (fileType === 'png' || fileType === 'PNG')
        const isPDF = (fileType === 'pdf' || fileType === 'PDF')
        const isType = isJPG || isJPEG || isPNG || isPDF
        const isSize = file.size / 1024 / 1024 < 50 // 限制小于50M

        if (!isSize) {
          this.$message({
            message: '上传图片最大不能超过50M',
            center: true
          })
        }
        if (!isType) {
          this.$message({
            message: '请上传正确的文件格式',
            center: true
          })
        }
        if (isSize && isType) {
          this.loading = this.$loading({
            lock: true,
            text: '正在上传',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0)'
          })
        }
        return isSize && isType
      },
      uploadPDF(res, file) {
        this.loading.close()
        if (res.code === '0000') {
          this.$message({
            message: '上传成功',
            center: true,
            type: 'success'
          })
          let data = {
            res: res,
            fileName: file
          }
          this.$emit('success', data)
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'warning'
          })
        }
      },
      success(res, file, fileList) {
        this.loading.close()
        if (res.code == '0000') {
          res.data.file = file
          res.data.url = this.global.DATA_DICT.resource_prefix + res.data.accessPath
          res.data.uuId = this.config.uploadData.uuId
          this.fileList.push(res.data)
          this.$emit('success', this.fileList)
          this.config.uploadData.uuId = new Date().getTime()
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'warning'
          })
        }
      },
      handleAvatarSuccess(res, file) {
        this.loading.close()
        if (res.code == '0000') {
          res.data.url = this.global.DATA_DICT.resource_prefix + res.data.accessPath
          setTimeout(() => {
            this.imageUrl = res.data.url
            this.$message({
              message: '上传成功',
              center: true,
              type: 'success'
            })
            this.$emit('success', res.data)
          }, 1000)
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'warning'
          })
        }
      },
      enclosureSuccess(res, file) {
        this.loading.close()
        if (res.code === '0000') {
          this.$message({
            message: '上传成功',
            center: true,
            type: 'success'
          })
          res.data.file = file
          res.data.url = this.global.DATA_DICT.resource_prefix + res.data.accessPath
          res.data.uploader = JSON.parse(localStorage.getItem('user')).userName
          res.data.uploadTime = parseInt(res.time)
          this.fileList.push(res.data)
          this.$emit('success', this.fileList)
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'warning'
          })
        }
      },
      error(err, file, fileList) {
        this.loading.close()
        this.$message({
          message: '上传失败',
          center: true,
          type: 'warning'
        })
      }
    },
    mounted() {
      if (this.config && this.config.initFileList && this.config.initFileList[0]) {
        this.imageUrl = this.config.initFileList[0].url
      }
      if (this.config && this.config.uploadUrl) {
        this.uploadExcelUrl = this.config.uploadUrl
      }
      if (this.config && !this.config.uploadData || !this.config.uploadData.uuId) {
        this.config.uploadData = this.config.uploadData || {}
        this.config.uploadData.uuId = new Date().getTime()
      }
    },
    created() {
      if (this.config && !this.config.uploadData || !this.config.uploadData.uuId) {
        this.config.uploadData = this.config.uploadData || {}
        this.config.uploadData.uuId = new Date().getTime()
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/FileUpload.vue